import { render, staticRenderFns } from "./PopupSetting.vue?vue&type=template&id=0c893ed6&scoped=true&"
import script from "./PopupSetting.vue?vue&type=script&lang=js&"
export * from "./PopupSetting.vue?vue&type=script&lang=js&"
import style0 from "./PopupSetting.vue?vue&type=style&index=0&id=0c893ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c893ed6",
  null
  
)

export default component.exports